<template>
	<div class="home2">
		<!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
		<!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
		<div class="container p-0">
			<div v-if="activateMode" class="alert alert-info">
				Activating account...
			</div>
			<h5>Due to problems with not working activation link please forward me an email you got from server or just contact me from your email you filled in registration form.</h5>
			<h5>W związku z problemami z linkiem aktywacyjnym do konta proszę o kontakt z adresu email który został użyty do rejestracji.</h5>
			<img
				src='data:image/png;base64,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' />
			<div class="row">
				<div class="col-sm mt-4">
					<canvas
						width="576px"
						height="448px"
						style="background-color: cadetblue;"
						id="game-canvas"
					></canvas>
				</div>
				<div class="col-sm">
					Random level list<br />

					<router-link
						:to="{ path: '/play-level/' + lvl.id + '/' + slug(lvl.name) }"
						v-for="lvl in randomLevels"
						:key="lvl.id"
					>
						<level-view
							:levelData="lvl.leveldata"
							:tileWidth="8"
							:levelName="lvl.name"
						></level-view>
					</router-link>

					<!-- <level-view :levelData="lvl.leveldata" :tileWidth="8" :levelName="lvl.name" v-for="lvl in randomLevels" :key="lvl.id"></level-view> -->
				</div>
			</div>

			<chat-box></chat-box>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import LevelView from '../components/LevelView.vue';
import ChatBox from '../components/ChatBox.vue';
const PREVIEW_COUNT = 8;
import slugify from 'slugify';

export default {
	name: 'Home',
	components: {
		LevelView,
		ChatBox
	},
	data: function() {
		return {
			name: '',
			gameInstance: void 0,
			randomLevels: [],
			activateMode: false
		};
	},
	computed: {
		showAlert() {
			return this.name.length > 4 ? true : false;
		}
	},
	mounted: function() {
		let hash = this.$route.params.hash;
		if (hash && this.$route.meta?.activate) {
			this.activateAccount(hash);
		} else if (hash && this.$route.meta?.reset) {
			this.resetPassword(hash);
		}

		this.runGame();
		this.loadRandomLevels();
	},
	beforeDestroy: function() {
		if (this.gameInstance) {
			this.gameInstance.stop();
		}
	},
	methods: {

		activateAccount(hash) {
			this.activateMode = true;
			fetch('/api/v1/public/activate/' + hash)
				.then(data => data.json())
				.then(data => {
					if (data.status == 'ok') {
						this.activateMode = false;
						this.$bvModal.show('login-modal');
					}
				});
		},

		resetPassword() {
			setTimeout(()=>{
				this.$bvModal.show('reset-pass-modal');
			}, 1);
		},

		slug(name) {
			return slugify(name);
		},

		loadRandomLevels() {
			fetch('/api/v1/levels/random/' + PREVIEW_COUNT)
				.then(data => data.json())
				.then(data => {
					this.randomLevels = data.lvlData;
				});
		},

		runGame() {
			/* eslint-disable */
			this.gameInstance = new Game({
				containerId: "game-canvas", 
				width: 576,
				height: 448,
				rootFolder: "robbo/",
				// testLevelData: levelData,
				levels: [
					"./levels/levels",      // RobboLevels
					"./levels/levels2",     // RobboLevels2
					"./levels/cejsoft",     // CejsoftLevels
					"./levels/boss",        // BossLevels
					"./levels/653924",      // Levels653924
					"./levels/antic-soft",  // AnticSoftLevels
					"./levels/janusoft",    // JanusoftLevels
					"./levels/robbocop",    // RobbocopLevels
				]
			});
			/* eslint-enable */
		}
	}
};
</script>
